<div class="last-added-background">
  <!--img class="control-loader" *ngIf="loading" src="/assets/css/images/platform/loader.gif" /-->
  <sem-loader [showLoader]="loading"></sem-loader>
  @if (lastRecordValue?.Url.length > 0) {
    <a [href]="lastRecordValue?.Url"></a>
  }

  @if (lastRecordValue) {
    <sem-image-viewer [mediaId]="lastRecordValue.LastMedia?.Id" [height]="550" [width]="550"></sem-image-viewer>
  }

  @if (lastRecordValue) {
    <div class="bottom-left-ribbon">
      <p>{{lastRecordValue.CreatedDate | date: 'dd.MM.yyyy':'CET'}}</p>
      <p>{{lastRecordValue.Title}}</p>
    <!--p>{{translationsService.translate('WebGalis_Module_GalisWeb_LastRecords')}}</p-->
  </div>
}
</div>